import { useTranslation } from 'react-i18next';
import { ISearchProps } from './app-header/app-header';
import { SearchModule } from './search-module';
import { SearchModuleExtension } from './search-module-extension';

export function SearchForm({
  activeModule,
  onChangeModule,
  searchBy,
  onSetSearchBy,
  handleFormSubmit,
}: ISearchProps) {
  const { t } = useTranslation();
  const modules = [
    {
      name: 'location',
      extension: 'location',
      label: t('search-form-label-where'),
      placeholder: t('search-form-placeholder-destinations'),
    },
    {
      name: 'startDate',
      extension: 'datepicker',
      label: t('search-form-label-when'),
      placeholder: t('search-form-placeholder-add-dates'),
    },
  ];

  const searchModuleProps = (module: { name: string; label: string; placeholder: string }) => ({
    onChangeModule,
    activeModule,
    searchBy,
    name: module.name,
    label: module.label,
    placeholder: module.placeholder,
    handleFormSubmit,
    onSetSearchBy,
  });

  const showExtension =
    activeModule === 'location' || activeModule === 'startDate' || activeModule === 'endDate';

  return (
    <form className="search-form" onSubmit={(e) => e.preventDefault()}>
      {modules.map((module) => (
        <div className={`module-container ${module.name}`} key={`m-${module.name}`}>
          <SearchModule {...searchModuleProps(module)} />
          {showExtension &&
            ((module.extension === 'datepicker' &&
              (activeModule === 'endDate' || activeModule === 'startDate')) ||
              activeModule === module.extension) && (
              <SearchModuleExtension
                onChangeModule={onChangeModule}
                activeModule={activeModule}
                searchBy={searchBy}
                onSetSearchBy={onSetSearchBy}
                handleFormSubmit={handleFormSubmit}
              />
            )}
        </div>
      ))}
    </form>
  );
}
